export default __webpack_public_path__ + "static/filters-dark-mode-5c0c98023c5d6e95309d7e7337dd8b61.png";